<template>
    <div class="configurator">
        <div class="configurator__editor__spinner" v-if="!hasProduct || !dataLoaded">
            <svg class="lds-spinner" width="43px" height="43px" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                 preserveAspectRatio="xMidYMid"
                 style="background-image: none; background-position: initial initial; background-repeat: initial initial;">
                <g transform="rotate(0 50 50)">
                    <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                 begin="-1.0999999999999999s" repeatCount="indefinite"></animate>
                    </rect>
                </g>
                <g transform="rotate(30 50 50)">
                    <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                 begin="-1s" repeatCount="indefinite"></animate>
                    </rect>
                </g>
                <g transform="rotate(60 50 50)">
                    <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                 begin="-0.8999999999999999s" repeatCount="indefinite"></animate>
                    </rect>
                </g>
                <g transform="rotate(90 50 50)">
                    <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                 begin="-0.7999999999999999s" repeatCount="indefinite"></animate>
                    </rect>
                </g>
                <g transform="rotate(120 50 50)">
                    <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                 begin="-0.7000000000000001s" repeatCount="indefinite"></animate>
                    </rect>
                </g>
                <g transform="rotate(150 50 50)">
                    <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                 begin="-0.6s" repeatCount="indefinite"></animate>
                    </rect>
                </g>
                <g transform="rotate(180 50 50)">
                    <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                 begin="-0.5s" repeatCount="indefinite"></animate>
                    </rect>
                </g>
                <g transform="rotate(210 50 50)">
                    <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                 begin="-0.39999999999999997s" repeatCount="indefinite"></animate>
                    </rect>
                </g>
                <g transform="rotate(240 50 50)">
                    <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                 begin="-0.3s" repeatCount="indefinite"></animate>
                    </rect>
                </g>
                <g transform="rotate(270 50 50)">
                    <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                 begin="-0.19999999999999998s" repeatCount="indefinite"></animate>
                    </rect>
                </g>
                <g transform="rotate(300 50 50)">
                    <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                 begin="-0.09999999999999999s" repeatCount="indefinite"></animate>
                    </rect>
                </g>
                <g transform="rotate(330 50 50)">
                    <rect x="47.5" y="11" rx="9.5" ry="2.2" width="5" height="20" fill="#dcb47d">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.2s"
                                 begin="0s" repeatCount="indefinite"></animate>
                    </rect>
                </g>
            </svg>
            <span>3D-Konfigurator wird geladen...</span>
        </div>

        <expivi-viewer @clicked:cart="cartButtonClickHandler" v-show="hasProduct && dataLoaded"></expivi-viewer>

        <div class="configurator__editor" v-if="hasProduct && dataLoaded">
            <!-- Header -->
            <div class="configurator__editor__header">
                <div class="title" v-if="!hasProduct">Personalisieren</div>
                <div class="title" v-if="hasProduct">{{ product.name }}</div>
                <progress-bar></progress-bar>
            </div>

            <!-- Step-Container -->
            <div class="configurator__editor__body">
                <div class="steps__body">
                    <!-- Interchangeable Content -->
                    <router-view-slide-transition>
                        <keep-alive>
                            <router-view @clicked:cart="cartButtonClickHandler"></router-view>
                        </keep-alive>
                    </router-view-slide-transition>
                </div>
            </div>
        </div>

        <input type="hidden" id="configuration" name="configuration" ref="configuration">
        <input type="hidden" id="image" name="image" ref="image">
        <input type="hidden" id="price" name="single_price" ref="singlePrice">
        <input type="hidden" id="quantity" name="quantity" ref="quantity">
    </div>
</template>

<script>
    import {mapGetters, mapState, mapActions, mapMutations} from "vuex"
    import AttributeTree                                    from "./expivi/attributes/AttributeTree"
    import Attribute                                        from "./expivi/attributes/Attribute"
    import ExpiviViewer                                     from "./components/expivi/ExpiviViewer"

    export default {
        name:       'app',
        components: {ExpiviViewer},
        data:       function () {
            return {
                preConfiguration: null,
                dataLoaded:       false,
            }
        },
        computed:   {
            ...mapGetters(['hasProduct']),
            ...mapState(['product'])
        },
        created:    function () {
            this.loadProduct()
                .then(product => {
                    let filteredMeta = product.meta_data.filter(meta => meta.key === 'pre_configuration' && meta.value !== 'null')

                    if (filteredMeta.length > 0) {
                        this.preConfiguration = JSON.parse(filteredMeta[0].value)
                    }

                    this.$expiviReady.then(expivi => {
                        this.loadAttributes()

                        if (this.preConfiguration != null) {
                            expivi.loadConfiguration({
                                bundle_uuid:         null,
                                configured_products: this.preConfiguration
                            }).then(() => {
                                this.dataLoaded = true
                                this.refreshExpivi()
                            })
                        } else {
                            this.dataLoaded = true
                            this.refreshExpivi()
                        }

                        expivi._events.onChange.subscribe(this.expiviChangeHandler)
                    });
                })
        },
        methods:    {
            ...mapActions(['loadProduct']),
            ...mapMutations([
                'updateProduct',
                'updateProductSelectionAttributes',
                'updateRefinementAttributes',
                'updateCustomizationPositions',
                'addCustomizationPosition'
            ]),

            refreshExpivi: function () {
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'))
                    // Remove the loader backdrop
                    let backdrop = document.getElementById('xpv__viewer_load_backdrop')
                    if (backdrop) {
                        backdrop.parentNode.removeChild(backdrop);
                    }
                }, 10)
            },

            /**
             * Sortiert die Attribute, die von Expivi geliefert werden.
             */
            sortRawAttributes: function (attributes) {
                attributes.sort((a, b) => {
                    if (a.position < b.position) {
                        return -1
                    }

                    if (a.position > b.position) {
                        return 1
                    }

                    return 0
                });
            },

            /**
             * Creates the attribute trees from the raw expivi attributes
             */
            loadAttributes: function () {
                window.expivi.getProductAttributes()
                    .then(rawAttributes => {
                        this.sortRawAttributes(rawAttributes)

                        let currentTree = null

                        for (let attributeData of rawAttributes) {
                            let attribute = new Attribute(attributeData);


                            if (attribute.getType() === 'step' && attribute.getPivotAttributeParentId() === null) {
                                currentTree = new AttributeTree(attribute);
                                this.updateTree(currentTree)
                            } else if (currentTree !== null) {
                                currentTree.insert(attribute);
                            }
                        }
                    })
            },

            /**
             * Updates the correct property on the Vuex store.
             * In case of the customizationType positions, the will be added to the array.
             *
             * @param tree
             */
            updateTree: function (tree) {
                let type = tree.getRoot().getDescription()

                switch (type) {
                    case 'mytw_step_productselect':
                        this.updateProductSelectionAttributes(tree)
                        break
                    case 'mytw_step_refinement':
                        this.updateRefinementAttributes(tree)
                        break
                    case 'mytw_step_position':
                        this.addCustomizationPosition(tree)
                        break
                }
            },

            /**
             * Notifies the changes of an event.
             *
             * @param $event
             */
            expiviChangeHandler: function ($event) {
                if ($event.name === 'buildready' || $event.name === 'buildupdated' || $event.name === 'attribute') {
                    //console.log('EXPIVI Event Name:', $event.name);
                    //console.log('EXPIVI Event Payload:', $event.payload);
                }
            },

            cartButtonClickHandler: function () {
                this.$expiviReady
                    .then(expivi => {
                        window.expivi.saveConfiguration(768, 768)
                            .then(configuredBundle => {

                                return expivi.getPrice().then(price => {
                                    let configuredProducts = configuredBundle.configured_products
                                    let thumbnail          = configuredProducts[0].thumbnail
                                    delete configuredProducts[0].thumbnail
                                    configuredProducts[0].wp_product_id = this.product.id

                                    let configuration = encodeURIComponent(JSON.stringify(configuredProducts));

                                    this.$refs.configuration.value = configuration
                                    this.$refs.image.value         = thumbnail
                                    this.$refs.singlePrice.value   = price
                                    this.$refs.quantity.value      = this.$store.state.amount

                                    let form = document.getElementById('configurator-cart');

                                    if (form) {
                                        setTimeout(() => form.submit(), 100)
                                    }
                                })
                            })

                    })
                    .catch(error => {
                        console.log('ERROR while saving', error)
                    })
            }
        },
    }
</script>
